<template lang="pug">
form.form-horizontal(role="form", v-if='group', @submit.prevent="save")
  template(v-if="showGeneralPart")
    .form-group(:class='{"has-error": modalErrors["name"]}')
      label.col-sm-2(for="inputName") {{$t("groups.createModal.fields.name.label")}}
      .col-sm-10
        input.form-control(v-model='name', :placeholder='$t("groups.createModal.fields.name.placeholder")', name='inputName', ref="inputName")
    .form-group(:class='{"has-error": modalErrors["typeGroup"]}')
      label.col-sm-2 {{$t("groups.createModal.fields.type.label")}}
      .col-sm-10
        select.form-control(v-model='typeGroup')
          option(:value='-1') {{$t("groups.createModal.fields.type.placeholder")}}
          option(:value='type', v-for='type in allTypes') {{$t("groups.types." + type)}}  

  template(v-if="showPagePart")
    .alert.alert-success
      | Le page est actuellement disponible à l'adresse suivante : 
      a(:href="'https://groopus.com/' + group.url", target="_blank") {{'https://groopus.com/' + group.url}}
    .form-group
      .col-sm-12
        .alert.alert-info Toutes les informations (conversations, les événements, les présences, les fichiers) sont toujours privées à un groupe et non accessibles aux autres utilisateurs de GroopUs. Mais chaque groupe possède une page sur laquelle vous pouvez décider de mettre les dates de vos événements, des photos, des fichiers, ... afin de promouvoir votre groupe (comme par exemple <a href='https://groopus.com/danstoncuivre' target='_blank'>https://groopus.com/danstoncuivre</a>). Choisissez ici si vous voulez que cette page soit visible pour tout le monde ou uniquement les membres de votre groupe.
    .form-group(:class='{"has-error": urlIsNotFree}')
      label.col-sm-2(for="url") {{$t("groups.createModal.fields.publicUrl.label")}}
      .col-sm-10
        .input-group
          .input-group-addon https://groopus.com/
          input.form-control(v-model='publicUrlOrCalculated', name='url')
        template(v-if='urlIsNotFree !== false')
          span.help-block.text-danger(v-if="urlIsNotFree == true") {{$t('groups.createModal.fields.publicUrl.urlIsNotFree')}}
          span.help-block.text-danger(v-else-if="urlIsNotFree == 'RestrictedURL'") {{$t('groups.createModal.fields.publicUrl.restrictedUrl')}}
          span.help-block.text-danger(v-else) {{$t('groups.createModal.fields.publicUrl.malformedUrl')}}
        template(v-else)
          span.help-block {{$t('groups.createModal.fields.publicUrl.emptyIfYouWant')}}
    .form-group
      label.col-sm-2(for="groupSentence") {{$t("groups.createModal.fields.sentence.label")}}
      .col-sm-10
        input.form-control(v-model='groupSentence', name='groupSentence', :placeholder='$t("groups.createModal.fields.sentence.placeholder")')
    .form-group
      label.col-sm-2(for="groupDescription") {{$t("groups.createModal.fields.description.label")}}
      .col-sm-10
        textarea.form-control(rows='6', v-model='groupDescription', name='groupDescription', :placeholder='$t("groups.createModal.fields.description.placeholder")')
    .form-group
      label.col-sm-2 {{$t("groups.createModal.fields.visibility.label")}}
      .col-sm-10
        .radio
          label
            input(type='radio', name='private', v-model='isPrivate', :value='false')
            | {{$t("groups.createModal.fields.checkPublic.label")}}
            .help-block {{$t("groups.createModal.fields.checkPublic.help")}}
      .col-sm-offset-2.col-sm-10
        .radio
          label
            input(type='radio', name='private', v-model='isPrivate', :value='true')
            | {{$t("groups.createModal.fields.checkPrivate.label")}}
            .help-block {{$t("groups.createModal.fields.checkPrivate.help")}}
</template>
<script type="text/javascript">
import {mapGetters} from 'vuex'
import api from '@/utils/api'
import $ from 'jquery'
import latinise from '@/utils/latinise'

export default {
  props: {
    group: {
      type: Object
    },
    part: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      id: null,
      name: '',
      isPrivate: false,
      typeGroup: -1,
      publicUrl: undefined,
      urlIsNotFree: false,
      groupSentence: null,
      groupDescription: ''
    }
  },
  mounted () {
    this.initDataFromGroup()
  },
  computed: {
    ...mapGetters('groops', [
      'allTypes'
    ]),
    showGeneralPart () {
      return this.part === 'all' || this.part === 'general'
    },
    showPagePart () {
      return this.part === 'all' || this.part === 'page'
    },
    modalErrors () {
      let modalErrors = []
      if (this.showGeneralPart) {
        if (this.name.trim() === '') {
          modalErrors['name'] = 'empty'
        }
        if (this.typeGroup === -1) {
          modalErrors['typeGroup'] = 'empty'
        }
      }
      return modalErrors
    },
    mustHaveIsComplete () {
      return Object.keys(this.modalErrors).length === 0
    },
    publicUrlOrCalculated: {
      get () {
        if (this.publicUrl !== undefined) {
          return this.publicUrl
        }
        return latinise(this.name.toLowerCase()).replace(/[^a-zA-Z0-9]+/g, '').replace(/(^-+|-+$)/g, '')
      },
      set (value) {
        this.publicUrl = value
      }
    }
  },
  methods: {
    focusOnInput () {
      $(this.$refs.inputName).focus()
    },
    initDataFromGroup () {
      if (this.group === null) {
        return
      }
      this.id = this.group.id
      this.name = this.group.name
      this.isPrivate = !this.group.isPublic
      this.typeGroup = this.group.type
      this.publicUrlOrCalculated = this.group.url
      this.groupSentence = this.group.pageSentence
      this.groupDescription = this.group.description
    },
    setType (type) {
      this.typeGroup = type || '-1'
    },
    save () {
      if (!this.mustHaveIsComplete) {
        this.$emit('error')
        return
      }
      if (this.showPagePart && this.urlIsNotFree) {
        this.$emit('error')
        return
      }
      let data = {}
      if (this.showGeneralPart) {
        data.name = this.name
        data.type = this.typeGroup
      }
      if (this.showPagePart) {
        data.isPublic = !this.isPrivate
        data.baseUrl = this.publicUrlOrCalculated
        data.sentence = this.groupSentence
        data.description = this.groupDescription
      }
      if (this.id == null) {
        api.post('/group', {
          name: this.name,
          type: this.typeGroup,
          isPublic: !this.isPrivate
        }).then((response) => {
          this.id = response.data.group
          this.$store.dispatch('groops/addNewGroop', response.data.group)
          this.$emit('success', response.data.group)
        }).catch(() => {
          this.$emit('error')
        })
      } else {
        api.put(`/public/group/${this.id}/infos`, data)
        .then((response) => {
          for (let k in response.data) {
            this.group[k] = response.data[k]
          }
          this.$emit('success')
        }).catch(() => {
          this.$emit('error')
        })
      }
    }
  },
  watch: {
    group () {
      this.initDataFromGroup()
    },
    publicUrlOrCalculated () {
      if (this.publicUrlOrCalculated === '') {
        this.urlIsNotFree = false
        return
      }
      api.get('/public/groupAtUrl', {
        params: {
          url: this.publicUrlOrCalculated,
          groupId: this.group.id
        }
      }).then((response) => {
        this.urlIsNotFree = !response.data.isFree
      }).catch((error) => {
        this.urlIsNotFree = error.response.data.error || 'BadURL'
      })
    },
    mustHaveIsComplete (newValue) {
      this.$emit('update:complete', newValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupEditor.vue?2e4c0cb6